// extracted by mini-css-extract-plugin
export default {"modal-wrong-network":"CheckNetwork_modal-wrong-network__c0d03"};